module.exports = __webpack_public_path__ + "static/media/dashboard-setup.b1897196.png";